<template>
  <div class="playlet">
    <el-card class="box-card">
      <!-- 选择区 -->
      <div class="selectionArea">
        <div class="item">
          <span class="title">文章名称</span>
          <el-input
            v-model.trim="parameter.name"
            clearable
            placeholder="请输入"
          />
        </div>
        <!-- <div class="item">
          <span class="title">别名</span>
          <el-input
            v-model="parameter.alias_name"
            clearable
            placeholder="请输入"
          />
        </div>
        <div class="item">
          <span class="title">视频平台</span>
          <el-select
            v-model="parameter.type"
            clearable
            placeholder="请选择"
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="item in states"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="title">视频类型</span>
          <el-select
            v-model="parameter.video_type"
            clearable
            placeholder="请选择"
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="item in statestype"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            />
          </el-select>
        </div> -->
        <!-- <div class="item">
          <span class="title">小程序</span>
          <el-select
            v-model="parameter.app_id"
            clearable
            placeholder="请选择"
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="item in statesAppid"
              :key="item.id"
              :label="item.account_name"
              :value="item.app_id"
            />
          </el-select>
        </div> -->
        <div class="item">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            @click="search"
          >搜索</el-button>
          <el-button
            size="mini"
            type="info"
            icon="el-icon-refresh"
            @click="reset"
          >重置</el-button>
          <!-- <el-button
            size="mini"
            type="success"
            icon="el-icon-s-help"
            @click="add"
          >创建</el-button> -->
        </div>
      </div>
    </el-card>

    <el-card>
      <!-- 主体区 -->
      <div>
        <el-table
          v-loading="loading"
          :data="tableData.list"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="id"
            width="55"
            align="center"
          />
          <!-- <el-table-column
            prop="name"
            label="视频名称"
            width="400"
            align="center"
          > <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
          </template>
          </el-table-column> -->
          <el-table-column
            prop="name"
            label="文章名称"
            width="500"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.name }}</div>
                <div class="ellipsis">{{ scope.row.name }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="type_text"
            label="文章类型"
            align="center"
          >
            <template scope="scope">
              <el-tag>{{ scope.row.category_text }}</el-tag>
            </template>
          </el-table-column> 
          <!-- <el-table-column
            prop="alias_name"
            width="400"
            label="别名"
            align="center"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content">{{ scope.row.alias_name }}</div>
                <div class="ellipsis">{{ scope.row.alias_name }}</div>
              </el-tooltip>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="type_text"
            label="平台"
            align="center"
          >
            <template scope="scope">
              <el-tag>{{ scope.row.type_text }}</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="video_type_text"
            label="视频类型"
            width="100"
            align="center"
          /> -->
          <!-- <el-table-column
            prop="virtual_likes"
            label="虚拟点赞数"
            width="100"
            align="center"
          />
          <el-table-column
            prop="virtual_heat"
            label="虚拟热度"
            width="100"
            align="center"
          />
          <el-table-column
            prop="recommend_all_ad_text"
            label="文章开头视频广告"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.row.article_start_ad==2?"开启":'关闭' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="recommend_all_ad_text"
            label="文章激励广告"
            align="center"
          >
            <template scope="scope">
              <span>{{ scope.row.open_encourage==2?"开启":'关闭' }}</span>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="cover_path"
            label="封面路径"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">{{ scope.row.cover_path }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="video_path"
            label="视频路径"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">{{ scope.row.video_path }}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="ad_type_text"
            label="小程序"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">
                <div
                  v-for="(value, key) in scope.row.applet_info"
                  :key="key"
                >
                  <span>
                    {{ value.account_name }}({{ value.app_id }})
                  </span>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="ad_type_text"
            label="小程序"
            width="300"
            align="center"
          >
            <template slot-scope="scope">
              <div class="ellipsis">
                <div
                  v-for="(value, key) in scope.row.applet_info"
                  :key="key"
                >
                  <span>
                    {{ value.account_name }}({{ value.app_id }})
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_at_text"
            label="创建时间"
            width="180"
            align="center"
          />
          <el-table-column
            label="操作"
            min-width="300"
            align="center"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="chooser(scope.row)"
              >选择</el-button>
            </template>
          </el-table-column></el-table>
      </div>
      <pagination-right
        :total="tableData.total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </el-card>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { videoSettingAdd, videoSettingUpdate, appletlistrw } from '@/api/sourceMaterial.js'
import { articleSettinglist, articleSettingdelete, articleSettingdetails } from '@/api/workWechat.js'
export default {
  name: 'Playlet',
  components: {
    PaginationRight
  },
  data() {
    return {
      parameter: {
        page: 1,
        page_size: 10,
        name: null,
        // app_id: ''
        // alias_name: null,
        // type: null
      },
      loading: false,
      states: [
        { id: 1, value: '抖音' },
        { id: 2, value: '快手' }
      ],
      statestype: [
        { id: 1, value: '推荐' },
        { id: 2, value: '娱乐' },
        { id: 3, value: '搞笑' },
        { id: 4, value: '生活' }
      ],
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      check: undefined,
      priwdialogVisible: false,
      dialogVisiblenotes: false,
      showAllRows: false,
      statesAppid: []
    }
  },
  computed: {
    toggleIcon() {
      return this.showAllRows ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    }
  },
  created() {

  },
  mounted() {},
  methods: {
    send(){
    this.getDatas()
    this.getlist()
    },
    clickslose() {
      this.dialogVisiblenotes = false
      this.getDatas()
      this.$forceUpdate()
    },
    getDisplayText(key) {
      if (key === 'encourage_ad') {
        return '激励-'
      } else if (key === 'insert_screen_ad') {
        return '插屏'
      } else if (key === 'video_patch_ad') {
        return '视频贴片'
      } else {
        return ''
      }
    },
    // 删除
    async myDelete(row) {
      // this.$confirm('您确定删除吗')
      //   .then(async () => {
      //     await videoSettingDelete({ id: row.id })
      //     this.getDatas()
      //     this.$message({
      //       message: '删除成功',
      //       type: 'success'
      //     })
      //   })
      //   .catch(() => {})
      this.$confirm('您确定删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          articleSettingdelete({
            id: row.id
          }).then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.getDatas()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    async getlist() {
      const data = await appletlistrw({
        page: 1,
        page_size: 100,
        keyword: null,
        mini_program_type: 4
      })
      this.statesAppid = data.data.list
    },
    toggleRows() {
      this.showAllRows = !this.showAllRows
    },
    updata() {
      this.dialogVisiblenotes = false
    },
    bandtakenotes(row) {
      this.dialogVisiblenotes = true
      this.$nextTick(() => {
        this.$refs.bandstaffnotesview.send(row)
      })
    },
    async look(id) {
      const data = await articleSettingdetails({
        id
      })
      console.log('data', data.data)
      this.priwdialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.timepreview.send(data.data)
      }, 100)
    },

    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.add.send(1)
        // this.$refs.add.reset()
        // this.$refs.add.sendr()
      })
    },
    editrow(row) {
      this.check = row
      this.dialogVisible = true
      this.$nextTick(() => {
        // this.$refs.add.sendr(row)
        this.$refs.add.send(2, row)
      })
    },

    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    async getDatas() {
      // this.loading = true
      const data = await articleSettinglist(this.parameter)
      this.tableData = data.data
      // this.loading = false
    },
    fetchPageSize(e) {
      this.parameter.page_size = e
      this.getDatas()
    },

    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getDatas()
    },

    handleClose() {
      this.check = undefined
      this.dialogVisible = false
    },

    // 提交
    async determine(obj, arr) {
      console.log('obj:', obj)
      try {
        obj.id ? await videoSettingUpdate(obj) : await videoSettingAdd(obj)
        this.$message({
          message: obj.id ? '修改成功' : '创建成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.$refs.add.reset()
        this.getDatas()
      } catch (error) {
        this.$refs.add.sendr(obj, 999, arr)
      }
    },
    // 搜索
    search() {
      this.parameter.page = 1
      this.getDatas()
    },

    // 重置
    reset() {
      this.parameter = {
        name: null,
        // alias_name: null,
        // type: null,
        page: 1,
        page_size: 10,
        // video_type: null,
        // app_id: ''
      }
      this.getDatas()
    },
    close() {
      this.getDatas()
    },
    updatar() {
      this.dialogVisible = false
      this.getDatas()
    },
    chooser(item){
      this.$emit('wenzhang',item)
    }
  }
}
</script>

<style scoped>
.playlet {
  margin: 30px;
  width: 95%;
  margin: 0 auto;
}
.el-card {
  margin-top: 20px;
}
.selectionArea {
  display: flex;
  flex-wrap: wrap;
}

.item {
  display: flex;
  align-items: center;
  flex-basis: calc(33.33% - 10px);
  margin-right: 10px;
  margin-bottom: 10px;
}

.title {
  white-space: pre;
  display: inline-block;
  margin-right: 7px;
}

.button-group {
  flex-basis: 100%; /* 按钮组占据一整行宽度 */
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.hidden-row {
  display: none;
}
.toggle-button {
  cursor: pointer;
  text-align: center;
}
</style>

